// src/stores/hotkeyStore.js
// import { writable } from "svelte/store";

// function createHotkeyStore() {
//     const { subscribe, update } = writable({});

//     function register(keyCombo, callback) {
//         update((map) => {
//             map[keyCombo] = callback;
//             return map;
//         });
//     }

//     function unregister(keyCombo) {
//         update((map) => {
//             delete map[keyCombo];
//             return map;
//         });
//     }

//     return { subscribe, register, unregister };
// }

// export const hotkeys = createHotkeyStore();

// hotkeyStore.js
import { writable, get } from 'svelte/store';

function createHotkeyStore() {
    const store = writable({});

    function register(keyCombo, callback) {
        store.update((map) => ({
            ...map,
            [keyCombo.toLowerCase()]: callback
        }));
    }

    function unregister(keyCombo) {
        store.update((map) => {
            const next = { ...map };
            delete next[keyCombo.toLowerCase()];
            return next;
        });
    }

    function trigger(event) {
        const parts = [];

        if (event.ctrlKey || event.metaKey) {
            parts.push('ctrl');
        }

        if (event.altKey) {
            parts.push('alt');
        }

        if (event.shiftKey) {
            parts.push('shift');
        }

        parts.push(event.key.toLowerCase());

        const combo = parts.join('+');

        const callback = get(store)[combo];

        if (callback) {
            event.preventDefault();
            callback(event);
        }
    }

    return {
        subscribe: store.subscribe,
        register,
        unregister,
        trigger
    };
}

export const hotkeys = createHotkeyStore();
